var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comp-friendshipgroups container"},[_c('div',{staticClass:"listing"},_vm._l((_vm.groups),function(g,i){return _c('div',{key:i,staticClass:"listing-row"},[_c('router-link',{attrs:{"to":_vm.linkTo(g)}},[_vm._v(" "+_vm._s(g.split(':')[0])+" ")])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }